export const ORDER_STATUS_DATA = "ORDER_STATUS_DATA";
export const ORDER_STATUS_ERROR_DATA = "ORDER_STATUS_ERROR_DATA";
export const ORDER_STATUS_HIDE_ERROR_DATA = "ORDER_STATUS_HIDE_ERROR_DATA";
export const ORDER_STATUS_START_LOADER = "ORDER_STATUS_START_LOADER";
export const ORDER_STATUS_STOP_LOADER = "ORDER_STATUS_STOP_LOADER";
